import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const PHONE = "917719779448"; // +91 77197 79448 without +/spaces
const MESSAGE =
  "Hi APEX Innovation Solutions, I'd like to connect about a project.";

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay so it doesn't compete with the hero animation
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with APEX Innovation Solutions on WhatsApp"
      data-testid="whatsapp-cta"
      initial={{ opacity: 0, scale: 0.7, y: 24 }}
      animate={{
        opacity: visible ? 1 : 0,
        scale: visible ? 1 : 0.7,
        y: visible ? 0 : 24,
      }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      className="fixed bottom-5 right-5 z-[60] inline-flex items-center gap-2.5 pl-2.5 pr-4 py-2.5 rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)] hover:bg-[#1ebe57] transition-colors duration-300"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-75"
        />
        <svg
          viewBox="0 0 32 32"
          width="20"
          height="20"
          fill="currentColor"
          className="relative text-white"
          aria-hidden
        >
          <path d="M16.001 3.2c-7.078 0-12.8 5.723-12.8 12.8 0 2.256.598 4.472 1.735 6.428L3.2 28.8l6.526-1.708a12.756 12.756 0 006.275 1.63h.001c7.078 0 12.8-5.723 12.8-12.8 0-3.42-1.332-6.634-3.75-9.05a12.72 12.72 0 00-9.051-3.672zm0 23.317h-.001a10.63 10.63 0 01-5.42-1.486l-.389-.231-4.052 1.061 1.081-3.949-.253-.406a10.582 10.582 0 01-1.626-5.665c0-5.869 4.772-10.64 10.66-10.64 2.847 0 5.522 1.108 7.535 3.121a10.605 10.605 0 013.105 7.52c0 5.868-4.773 10.639-10.64 10.639zm5.83-7.972c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.827 1.04-1.014 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.951-.848-1.594-1.895-1.78-2.215-.187-.32-.02-.492.14-.652.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.026-.56-.08-.16-.72-1.734-.986-2.374-.26-.623-.524-.538-.72-.548l-.613-.011a1.174 1.174 0 00-.853.4c-.293.32-1.12 1.093-1.12 2.666 0 1.573 1.146 3.093 1.306 3.306.16.213 2.253 3.44 5.463 4.826.764.33 1.36.527 1.825.674.766.243 1.464.209 2.015.127.615-.092 1.892-.773 2.16-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z" />
        </svg>
      </span>
      <span className="font-semibold text-sm whitespace-nowrap">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
}
